import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@material-ui/core';
import T from 'i18n-react';
import { getLocale, countryListWithoutVIUS as countryList, businessType } from 'util/icwUtility';
import Select from 'react-select';
import { TextField } from 'icw-components/InputFields';
import UploadFiles from './components/UploadFiles';

const CompanyDetails = ({
  formik,
  productCategories,
  brFiles,
  exportLicenseFiles,
  videos,
  setBRFiles,
  setExportLicenseFiles,
  setVideos,
  handleSelectChange,
}) => {
  return (
    <>
      <Box py={2}>
        <Grid container spacing={2} justify='center' alignItems='center'>
          <Grid item xs={12} sm={12} md={12}>
            <Box
              fontSize='16px'
              fontWeight='bold'
              color='#1D293F'
              diplay='flex'
              justifyContent='center'
              py={1}>
              {T.translate('iSource.supplierForm.companyDetails.title')}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.form.companyName')}*
            </Box>
            <TextField
              name='companyName'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.companyName')}
              value={formik.values.companyName}
              error={!!(formik.touched.companyName && formik.errors.companyName)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.companyName && formik.errors.companyName}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.companyDetails.country')}*
            </Box>
            <Select
              name='country'
              styles={{
                control: (base) => ({
                  ...base,
                  marginTop: '8px',
                  marginBottom: '4px',
                  padding: '1px 0',
                  backgroundColor: 'transparent',
                  '&:hover': {
                    borderColor: '#000',
                  },
                  borderColor:
                    formik.touched.country && formik.errors.country
                      ? '#f44336'
                      : 'rgba(0, 0, 0, 0.23)',
                }),
              }}
              options={countryList.map((rec) => ({
                label: T.translate(`country.${rec.region}`),
                value: rec.region,
              }))}
              value={formik.country}
              onChange={(values) => handleSelectChange(values, 'country')}
              error={!!(formik.touched.country && formik.errors.country)}
              onBlur={() => formik.setFieldTouched('country', true, true)}
              placeholder={T.translate('iSource.placeholder.country')}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.country && formik.errors.country}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} justify='flex-start'>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.companyDetails.companyWebSite')}
            </Box>
            <TextField
              name='website'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.companyWebSite')}
              value={formik.values.website}
              onChange={formik.handleChange}
            />
          </Grid>
        </Grid>
      </Box>
      <Box py={2}>
        <Grid container spacing={2} justify='flex-start'>
          <Grid item xs={12} sm={12} md={12}>
            <Box fontSize='16px' fontWeight='bold' py={2}>
              {T.translate('iSource.supplierForm.contactDetails.title')}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.contactDetails.companyAddress')}
            </Box>
            <TextField
              name='address'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.companyAddr')}
              value={formik.values.address}
              onChange={formik.handleChange}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} justify='flex-start'>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.contactDetails.contactPerson')}*
            </Box>
            <TextField
              name='contactPerson'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.contactPerson')}
              value={formik.values.contactPerson}
              error={!!(formik.touched.contactPerson && formik.errors.contactPerson)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.contactPerson && formik.errors.contactPerson}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.contactDetails.companyEmail')}*
            </Box>
            <TextField
              name='email'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.email')}
              value={formik.values.email}
              error={!!(formik.touched.email && formik.errors.email)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.email && formik.errors.email}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} justify='flex-start'>
          <Grid item xs={12} sm={12} md={8}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.contactDetails.telephone')}*
            </Box>
            <Grid container spacing={2} justify='center' alignItems='center'>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  name='countryCode'
                  variant='outlined'
                  fullWidth
                  noLabel
                  placeholder={T.translate('iSource.placeholder.areaCode')}
                  value={formik.values.countryCode}
                  error={!!(formik.touched.countryCode && formik.errors.countryCode)}
                  setFieldTouched={formik.setFieldTouched}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>
              <Grid item xs={8} sm={8} md={8}>
                <TextField
                  name='phone'
                  variant='outlined'
                  fullWidth
                  noLabel
                  placeholder={T.translate('iSource.placeholder.phoneNumber')}
                  value={formik.values.phone}
                  error={!!(formik.touched.phone && formik.errors.phone)}
                  setFieldTouched={formik.setFieldTouched}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>
              <Grid item xs={12}>
                <Box fontSize='12px' fontWeight='500' color='red' mt={-2}>
                  {(formik.touched.countryCode && formik.errors.phone) ||
                    (formik.touched.phone && formik.errors.phone)}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} justify='flex-start'>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.companyDetails.businessType')}*
            </Box>
            <Select
              name='businessType'
              styles={{
                control: (base) => ({
                  ...base,
                  marginTop: '8px',
                  marginBottom: '4px',
                  padding: '1px 0',
                  backgroundColor: 'transparent',
                  '&:hover': {
                    borderColor: '#000',
                  },
                  borderColor:
                    formik.touched.businessType && formik.errors.businessType
                      ? '#f44336'
                      : 'rgba(0, 0, 0, 0.23)',
                }),
              }}
              options={businessType.map((rec) => ({
                label: T.translate(rec.label),
                value: rec.value,
              }))}
              value={formik.country}
              onChange={(values) => handleSelectChange(values, 'businessType')}
              onBlur={() => formik.setFieldTouched('businessType', true, true)}
              placeholder={T.translate('iSource.placeholder.options')}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.businessType && formik.errors.businessType}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <UploadFiles
        title={`${T.translate('iSource.supplierForm.companyDetails.uploadRB')}*`}
        files={brFiles}
        setFiles={setBRFiles}
      />
      <Box fontSize='12px' fontWeight='500' color='red'>
        {formik.errors.companyRegistration}
      </Box>
      <UploadFiles
        title={T.translate('iSource.supplierForm.companyDetails.ploadExportLicense')}
        files={exportLicenseFiles}
        setFiles={setExportLicenseFiles}
      />
      <UploadFiles
        title={T.translate('iSource.supplierForm.companyDetails.uploadVideo', {
          increaseBuyerInterest: (
            <Box component='span' color='#005EFF'>
              {T.translate('iSource.supplierForm.companyDetails.increaseBuyerInterest')}
            </Box>
          ),
        })}
        files={videos}
        setFiles={setVideos}
      />
      <Box py={2}>
        <Grid container spacing={2} justify='flex-start'>
          <Grid item xs={12} sm={12} md={12}>
            <Box fontSize='16px' fontWeight='bold' py={2}>
              {T.translate('iSource.supplierForm.productType.title')}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productType.productCategory')}
            </Box>
            <Select
              name='productCategories'
              styles={{
                control: (base) => ({
                  ...base,
                  marginTop: '8px',
                  marginBottom: '4px',
                  padding: '1px 0',
                  backgroundColor: 'transparent',
                  '&:hover': {
                    borderColor: '#000',
                  },
                  borderColor:
                    formik.touched.productCategories && formik.errors.productCategories
                      ? '#f44336'
                      : 'rgba(0, 0, 0, 0.23)',
                }),
              }}
              options={productCategories.map((pc) => ({
                value: pc.id,
                label: pc[`name_${getLocale().replace('-', '')}`],
              }))}
              value={formik.productCategories}
              onChange={(values) => handleSelectChange(values, 'productCategories')}
              onBlur={() => formik.setFieldTouched('productCategories', true, true)}
              isMulti
              placeholder={T.translate('iSource.placeholder.options')}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.productCategories && formik.errors.productCategories}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} justify='flex-start'>
          <Grid item xs={12} sm={12} md={12}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productType.majorProducts')}
            </Box>
            <TextField
              name='majorProducts'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.majorProducts')}
              value={formik.values.majorProducts}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              multiline
              rows={5}
              rowsMax={10}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

CompanyDetails.propTypes = {
  formik: PropTypes.object.isRequired,
  productCategories: PropTypes.array.isRequired,
  brFiles: PropTypes.array.isRequired,
  exportLicenseFiles: PropTypes.array.isRequired,
  videos: PropTypes.array.isRequired,
  setBRFiles: PropTypes.func.isRequired,
  setExportLicenseFiles: PropTypes.func.isRequired,
  setVideos: PropTypes.func.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
};

export default CompanyDetails;
